module.exports = __webpack_public_path__ + "img/ARAARE_logo_rund.2edbd1ad.svg";